import { Box, BoxProps } from "@cloudscape-design/components-themed";

interface IMultilineText {
  content: string;
  boxProps?: BoxProps;
}

/**
 * 複数行のテキストを改行を入れて表示する.
 */
const MultilineText = ({ content, boxProps }: IMultilineText) => {
  return (
    <>
      {content.split(/\r\n|\\r\\n/).map((line, index) => (
        <Box key={`${line}-${index}`} {...boxProps}>
          {line}
          <br />
        </Box>
      ))}
    </>
  );
};

export default MultilineText;
